var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:("driver-item-alarm-switch bolder iconfont icon-baojing cursor-pointer " + _vm.iconColor),attrs:{"title":_vm.iconDesc},on:{"click":_vm.showAlarmSwitch}})])}
var staticRenderFns = []

export { render, staticRenderFns }